import { DrawerClose } from '@/shadcn/ui/drawer'
import { ChevronsRight } from 'lucide-react'
import { DrawerDescription } from '@/shadcn/ui/drawer'
import { DrawerTitle } from '@/shadcn/ui/drawer'
import { DrawerHeader } from '@/shadcn/ui/drawer'
import { Typography } from '@/ui/atoms/typography/Typography'
import { DynamicEmbeddedWidget } from '@dynamic-labs/sdk-react-core'
import { Info } from '@/ui/molecules/info/Info'

export function GuestView() {
  return (
    <>
      <DrawerHeader className="gap-0 text-left">
        <DrawerClose className="mt-4 transition-colors hover:text-primary">
          <ChevronsRight className="h-4 w-4" />
        </DrawerClose>

        <DrawerDescription className="mt-6 mb-1 pl-1">
          <span className="flex items-center gap-1">
            <Typography variant="prompt">HypurrFi net position</Typography>
            <Info>The dollar value of your deposits minus your borrows in HypurrFi.</Info>
          </span>
        </DrawerDescription>
        <DrawerTitle className="pb-4 pl-1" asChild>
          <Typography variant="h1" className="text-4xl lg:text-4xl">
            0<span className="text-white/40">.00</span>
          </Typography>
        </DrawerTitle>
      </DrawerHeader>

      <div className="flex flex-col items-center justify-center gap-4">
        <div className="px-4 text-center">
          <Typography variant="p">Connect your wallet to see your HypurrFi overview.</Typography>
        </div>

        <DynamicEmbeddedWidget background="with-border" />
      </div>
    </>
  )
}
